import { render } from "./ProductSkeleton.vue?vue&type=template&id=9f22ee16&scoped=true"
const script = {}

import "./ProductSkeleton.vue?vue&type=style&index=0&id=9f22ee16&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f22ee16"]])

export default __exports__